var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowAnchor = function SvgArrowAnchor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.735 7.313 12.034 3.28a.84.84 0 0 0-1.25 0 1.036 1.036 0 0 0 0 1.363l2.184 2.396H4.884c-.492 0-.884.427-.884.964s.392.963.884.963h8.084l-2.185 2.383c-.34.371-.34.991 0 1.363a.86.86 0 0 0 .632.289.85.85 0 0 0 .631-.29l3.689-4.02c.164-.179.265-.427.265-.688a.97.97 0 0 0-.265-.689z"
  })));
};
export default SvgArrowAnchor;